export const AiMessageType = {
  THINKING: "thinking",
  SUGGESTION: "suggestion",
  WELCOME: "welcome", // Welcome message with avatar
  STAGE: "stage", // Stage indicator (analyzing, retrieving, generating)
  ERROR: "error", // Error message with retry link
};

// Initialization states for AI chat startup
export const InitializationState = {
  IDLE: 'idle',
  SKELETON: 'skeleton', // Shows skeleton UI while WebSocket connects
  LOADING_DOTS: 'loading_dots',
  WELCOME_READY: 'welcome_ready', // Welcome message displayed, ready for user input
};

// AI Processing Stages (from backend StageEvent)
export const AIStage = {
  IDLE: "IDLE",
  ANALYZING: "ANALYZING",
  CONNECTING_KB_AGENT: "CONNECTING_KB_AGENT",
  RETRIEVING: "RETRIEVING",
  GENERATING: "GENERATING",
  COMPLETE: "COMPLETE",
  ERROR: "ERROR",
  RATE_LIMIT_EXCEEDED: "RATE_LIMIT_EXCEEDED",
  INPUT_LOCKED: "INPUT_LOCKED",
};

// Event types from backend
export const EventTypes = {
  STAGE: "StageEvent",
  TOKEN: "TokenEvent",
  THINKING: "ThinkingEvent",
  ERROR: "ErrorEvent",
};

export const AIMessageBubbleType = {
  // no TEXT type since it's default
  LOADING_DOTS: "loading-dots",
  SUGGESTION: "suggestion",
  STAGE: "stage",
  THINKING: "thinking",
  TRY_AGAIN: "try-again",
};

/**
 * Error types to show on FE
 */
export const AIErrorType = {
  RATE_LIMIT_EXCEEDED: "RATE_LIMIT_EXCEEDED",
  INPUT_VALIDATION_ERROR: "INPUT_VALIDATION_ERROR",
  SERVER_ERROR: "SERVER_ERROR",
  SCHEMA_VALIDATION_ERROR: "SCHEMA_VALIDATION_ERROR",
};

/**
 * Session storage key for browser tab session ID
 * Used to identify unique browser tabs for event filtering
 */
export const SESSION_ID_KEY = 'ai-chat-session-id';
